module.exports = __webpack_public_path__ + "static/media/letrero.e29ffd9d.png";